export const generateValidPassword = () => {
  const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const specialChars = "!@#$%^&*()_+-=[]{}|;:',.<>?";

  // Ensure the password includes at least one character from each group
  const getRandomChar = (chars) => chars.charAt(Math.floor(Math.random() * chars.length));

  let password = [
    getRandomChar(upperCase),
    getRandomChar(lowerCase),
    getRandomChar(numbers),
    getRandomChar(specialChars),
  ];

  // Fill the rest of the password with random characters from all groups
  const allChars = upperCase + lowerCase + numbers + specialChars;
  for (let i = password.length; i <= 8; i++) {
    password.push(getRandomChar(allChars));
  }

  // Shuffle the password to avoid predictable patterns
  password = password.sort(() => Math.random() - 0.5);
  
  return password.join("");
};
